import { Destino } from './../../../models/destino.model';
import { Component  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';


declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-destino",
    templateUrl : "./destino.component.html",
    styleUrls : ["./destino.component.css"],
    providers: [FormService]
})

export class DestinoComponent {
    public rows = [];
      public actualRow;
      public destino: Destino;
      public form;
   
    matcher = new FormService();
     
    constructor(public _formService: FormService, private fb:FormBuilder){
        this.form = new FormGroup({
            residencial: new FormControl(''),
            destino_resd: new FormControl(''),
            equipamiento: new FormControl(''),
            clase_eq: new FormControl(''),
            actividad_eq: new FormControl(''),
            escala_eq: new FormControl(''),
            actividad: new FormControl(''),
            destino_act: new FormControl(''),
            infraestructura: new FormControl(''),
            destino_infr: new FormControl(''),
            otros: new FormControl(''),
            esp_otros: new FormControl(''),

        })

        if(!JSON.parse(localStorage.getItem("destino"))){
            localStorage.setItem("destino", JSON.stringify(this.rows));
        }else{  
            this.rows = JSON.parse(localStorage.getItem("destino"));
            this.form.controls['residencial'].setValue(this.rows[0]?this.rows[0].residencial:false);
            this.form.controls['destino_resd'].setValue(this.rows[0]?this.rows[0].destino_resd:'');
            this.form.controls['equipamiento'].setValue(this.rows[0]?this.rows[0].equipamiento:'');
            this.form.controls['clase_eq'].setValue(this.rows[0]?this.rows[0].clase_eq:'');
            this.form.controls['actividad_eq'].setValue(this.rows[0]?this.rows[0].actividad_eq:'');
            this.form.controls['escala_eq'].setValue(this.rows[0]?this.rows[0].escala_eq:'');
            this.form.controls['actividad'].setValue(this.rows[0]?this.rows[0].actividad:'');
            this.form.controls['destino_act'].setValue(this.rows[0]?this.rows[0].destino_act:'');
            this.form.controls['infraestructura'].setValue(this.rows[0]?this.rows[0].infraestructura:'');
            this.form.controls['destino_infr'].setValue(this.rows[0]?this.rows[0].destino_infr:'');
            this.form.controls['otros'].setValue(this.rows[0]?this.rows[0].otros:'');
            this.form.controls['esp_otros'].setValue(this.rows[0]?this.rows[0].esp_otros:'');
        }
       this.destino ={residencial:'',destino_resd:'',equipamiento:'',clase_eq:'',actividad_eq:'',escala_eq:'',actividad:'',destino_act:'',infraestructura:'',destino_infr:'',otros:'',esp_otros:'' }
    }

    add_destino(){
        //var checkdestino = event.value;
        localStorage.setItem("destino", JSON.stringify([]))
        this.actualRow = localStorage.getItem("destino");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            residencial:  this.form.value.residencial,
            destino_resd: this.form.value.destino_resd,
            equipamiento: this.form.value.equipamiento,
            clase_eq: this.form.value.clase_eq,
            actividad_eq: this.form.value.actividad_eq,
            escala_eq: this.form.value.escala_eq,
            actividad: this.form.value.actividad,
            destino_act: this.form.value.destino_act,
            infraestructura: this.form.value.infraestructura,
            destino_infr: this.form.value.destino_infr,
            otros: this.form.value.otros,
            esp_otros: this.form.value.esp_otros
     })
       
        localStorage.setItem("destino", JSON.stringify(this.rows));
        
    }

    delete_destino(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("destino", JSON.stringify(this.rows));
            }
        }
    }
}